import styled from 'styled-components';

import AdditionalDocumentsDropZone from 'components/AdditionalDocumentsDropZone/component';

export default styled(AdditionalDocumentsDropZone)`
  .dropzone {
    background-color: var(--white);
    border: none;
    color: 3px dashed var(--grey900);
    background-color: var(--grey100);
    border-radius: 10px;
    text-align: center;
    transform: scale(1);
    transition: all 0.2s ease-out;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 180px;
    padding: 20px;
    cursor: pointer;
    flex-direction: column;
    margin: 16px 0px;

    &.active-dropzone {
      border: 3px dashed var(--grey300);
    }

    &.error-dropzone {
      border: 3px dashed var(--accent700);
    }

    .files-container {
      display: flex;
      align-items: center;
      cursor: pointer;
      flex-wrap: wrap;
    }
    .dropzoneHelpActive {
      display: none;
    }

    &:focus {
      outline: none;
    }
  }

  .dropzoneActive {
    box-shadow: 0 3px 15px rgba(0, 0, 0, 0.2);
    transition: all 0.2s ease-in;
    .dropzoneHelpActive {
      display: block;
    }
    .dropzoneHelp {
      display: none;
    }
    .dropzoneHelpButton {
      visibility: hidden;
    }
  }

  .dropzoneHelp,
  .dropzoneHelpActive {
    color: var(--grey300);
    display: block;
    margin-bottom: 10px;
  }

  .dropzoneHelpActive {
    font-size: em(20);
  }

  .dropzoneError {
    color: var(--accent700);
    display: block;
    margin-bottom: 10px;
  }

  .imagesContainer {
    height: 205px;
    margin-bottom: 20px;
    overflow-y: hidden;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-top: -20px;
    display: flex;
  }

  .imageItem {
    height: 250px;
    margin-right: 15px;
    position: relative;
    flex: 0;
    flex-basis: 0;

    img {
      width: auto;
      height: 100%;
      display: block;
    }
    .deleteButton {
      display: none;
    }
    &:hover {
      .deleteButton {
        display: block;
      }
    }
  }

  .file-item {
    height: 180px;
    width: 100px;
    margin-right: 15px;
    position: relative;
    flex: 0;
    flex-basis: 0;
    padding: 10px;
    border-radius: 8px;
    margin: 5px;

    .delete-item-button {
      display: none;
    }
    &:hover {
      background: hsla(210, 10%, 90%, 0.29);
      .delete-item-button {
        display: block;
      }
    }
  }

  .type-containter {
    width: 80px;
    height: 100px;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    background-color: var(--white);
    display: inline-block;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #8e9fb2;
  }

  .item-name {
    font-size: 12px;
    color: var(--grey700);
    text-align: center;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    margin: 8px 0px;
  }

  .imageItemLoading {
    background-color: var(--white);
    text-align: center;
    display: flex;
    align-items: center;
  }

  .itemLoading {
    margin: 0 50px;
  }

  .delete-item-button {
    position: absolute;
    height: 20px;
    width: 20px;
    background-color: var(--white);
    cursor: pointer;

    content: '';
    border-radius: 20px;
    text-align: center;
    line-height: 20px;
    color: var(--grey300);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    top: -10px;
    right: -10px;
    background-color: var(--grey900);
    color: var(--white);
    .delete-item-icon {
      font-size: em(12);
    }
    svg {
      width: 1rem;
      fill: var(--white);
      height: 1rem;
    }
  }

  .loadingContainer {
    position: relative;
  }

  .loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .options {
    margin: 16px 0px;
  }

  .actions {
    margin: 16px 0px;
  }
`;
